export enum AppointmentStatus {
    agendamento_criado = 'agendamento_criado',
    agendamento_confirmado = 'agendamento_confirmado',
    agendamento_cancelado_usuario = 'agendamento_cancelado_usuario',
    agendamento_cancelado_empresa = 'agendamento_cancelado_empresa',
    agendamento_faltou = 'agendamento_faltou',
    agendamento_compareceu = 'agendamento_compareceu',
    agendamento_remarcado = 'agendamento_remarcado',
    agendamento_remarcado_descontar = 'agendamento_remarcado_descontar',
    agendamento_excluido = 'agendamento_excluido',
    agendamento_bloqueado = 'agendamento_bloqueado',
    agendamento_disponivel = 'agendamento_disponivel',
}

export enum AppointmentStatusFriendly {
    agendamento_criado = 'Agendado',
    agendamento_confirmado = 'Confirmado',
    agendamento_cancelado_usuario = 'Cancelado cliente',
    agendamento_cancelado_empresa = 'Cancelado empresa',
    agendamento_faltou = 'Faltou',
    agendamento_remarcado = 'Remarcado não descontar',
    agendamento_remarcado_descontar = 'Remarcado descontar',
    agendamento_compareceu = 'Compareceu',
}

export enum AppointmentStatusHelper {
    agendamento_criado = 'Agendado: agendamento criado',
    agendamento_confirmado = 'Confirmado: cliente informou que irá comparecer',
    agendamento_cancelado_usuario = 'Cancelado cliente: cliente cancelou. NÃO descontar sessão no controle de saldos',
    agendamento_cancelado_empresa = 'Cancelado empresa: nós cancelamos. NÃO descontar sessão no controle de saldos',
    agendamento_faltou = 'Faltou: cliente não compareceu. DESCONTAR sessão no controle de saldos',
    agendamento_remarcado = 'Remarcado não descontar: o cliente que faltou foi remarcado. NÃO descontar sessão no controle de saldos',
    agendamento_remarcado_descontar = 'Remarcado descontar: o cliente que faltou foi remarcado. DESCONTAR sessão no controle de saldos',
    agendamento_compareceu = 'Compareceu: o cliente compareceu no agendamento',
}
